import Grid from '@mui/material/Unstable_Grid2/Grid2'
import OneModal from '../../OneModal/OneModal'
import { Button, Typography } from '@mui/material'
import { showNotify } from '../../../Utils/Utils'
import { useContext, useState } from 'react'
import OneTextArea from '../../OneTextArea/OneTextArea'
import { WebSocketContext } from '../../../Providers/WebSocket/WebSocketContext'
import { OrdemServicoContext } from '../../../Providers/OrdemServicoContext/OrdemServicoContext'

const container = {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    justifyContent: 'start',
    gap: '20px'
}

const line = {
    display: 'flex',
    justifyContent: 'center'
}

const formGroup = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
}

const formGroupTextValue = {
    fontWeight: 'bold'
}

const formGroupLabel = {
    width: '130px'
}

const textAreaSx = {
    height: '100px'
}

const ModalCancelarOrdemServico = ({ open, setOpen, ordemServicoRef }) => {
    const ordemServico = { ...ordemServicoRef }

    if (!ordemServico) {
        showNotify('error', 'Houve um erro ao buscar ordem de serviço.')
        return
    }

    const { sendWs, addRoute } = useContext(WebSocketContext)
    const { buscarOrdensServico } = useContext(OrdemServicoContext)

    const [formData, setFormData] = useState({})

    const handleChange = (event) => {
        if (event.target.value != undefined) {
            if (event.target.type == 'checkbox') {
                setFormData({ ...formData, [event.target.name]: event.target.checked })
            } else {
                setFormData({ ...formData, [event.target.name]: event.target.value })
            }
        }
    }

    const handleSubmit = () => {
        if (!formData.solucao || formData.solucao.length < 15) {
            showNotify('warning', 'O motivo de cancelamento deve conter no mínimo 15 caracteres.')
            return
        }

        formData.id = ordemServico.id

        addRoute('cancelarOrdemServico', (msg) => {
            const { status, message } = msg.data

            if (status == 'error' || !status) {
                showNotify('error', message)
                return
            }

            showNotify('success', 'Ordem de serviço cancelada com sucesso!')
            setOpen(false)
            buscarOrdensServico()
        })

        sendWs('cancelarOrdemServico', {
            ordemServico: formData
        })
    }

    return (
        <OneModal
            open={open}
            setOpen={setOpen}
            titleText="Cancelar Ordem Serviço"
            fullWidth={true}
            maxWidth='sm'
        >
            <Grid sx={container}>
                <Grid sx={line}>
                    <Grid sx={formGroup}>
                        <Typography sx={formGroupLabel}>Ordem Serviço: </Typography>
                        <Typography sx={formGroupTextValue}>{ ordemServico.id }</Typography>
                    </Grid>
                </Grid>

                <Grid sx={line}>
                    <Grid sx={formGroup}>
                        <Typography>Cliente: </Typography>
                        <Typography sx={formGroupTextValue}>{ ordemServico.condominio }</Typography>
                    </Grid>
                </Grid>

                <Grid sx={line}>
                    <Grid sx={formGroup} xs>
                        <Typography>Motivo Cancelamento: </Typography>
                        <OneTextArea
                            name="solucao"
                            onChange={handleChange}
                            newSx={textAreaSx}
                        />
                        <Typography sx={{ alignSelf: 'start', fontSize: 12 }}>Campo obrigatório com no mínimo 15 caracteres</Typography>
                    </Grid>
                </Grid>

                <Grid sx={{ ...line, justifyContent: 'end', gap: '150px' }}>
                    <Button variant="contained" color="one_primary" onClick={handleSubmit}>Finalizar</Button>
                </Grid>
            </Grid>
        </OneModal>
    )
}

export default ModalCancelarOrdemServico
